import { router } from 'expo-router';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CheckIcon,
    H2Emphasized,
    Icon,
    isWeb,
    ScreenContainer,
    View,
    YStack,
} from 'smoothie';

import { apexWithdrawalRequestAtom } from '../../state/investmentAtoms';

export const WithdrawalSubmitted = () => {
    const apexWithdrawalRequest = useAtomValue(apexWithdrawalRequestAtom);

    return (
        <ScreenContainer
            containerProps={{
                justifyContent: isWeb ? 'flex-start' : 'space-between',
            }}
        >
            <YStack
                gap={24}
                justifyContent={isWeb ? 'flex-start' : 'space-between'}
                width="100%"
                maxWidth={500}
                alignSelf="center"
            >
                <YStack
                    marginTop={isWeb ? 50 : '30%'}
                    marginBottom={isWeb ? 100 : 0}
                >
                    <View
                        alignSelf="center"
                        padding={25}
                        borderRadius={20}
                        backgroundColor="$green1000"
                        marginTop={30}
                        marginBottom={30}
                    >
                        <Icon icon={CheckIcon} color="$white" size={30} />
                    </View>
                    <H2Emphasized marginTop={16} textAlign="center">
                        Transfer initiated!
                    </H2Emphasized>
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1000"
                        marginTop={8}
                        marginHorizontal={12}
                    >
                        Transfers are generally available in 4 - 6 business
                        days.
                    </BodyMediumRegular>
                </YStack>
                <View gap={8}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Continue"
                        onPress={() => {
                            if (apexWithdrawalRequest !== null) {
                                router.navigate({
                                    pathname: '/investments/account-overview',
                                    params: {
                                        apexAccountId:
                                            apexWithdrawalRequest.fromAccount
                                                ?.apexAccountId,
                                    },
                                });
                            } else {
                                router.navigate('/home/investment');
                            }
                        }}
                    />
                </View>
            </YStack>
        </ScreenContainer>
    );
};
